import { authorizationHeader } from '@picsart/growth-rc/services/auth';
import { getApiUrl, get } from '../httpService/index.js';

var fetchUserSubscription = function fetchUserSubscription() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$expand = _ref.expand,
    expand = _ref$expand === void 0 ? false : _ref$expand,
    scopeId = _ref.scopeId;
  var accessToken = arguments.length > 1 ? arguments[1] : undefined;
  var url = new URL("".concat(getApiUrl(), "/shop/subscription/info"));
  scopeId && url.searchParams.append('scopeId', scopeId);
  expand && url.searchParams.append('expand', 'true');
  return get(url.href, {
    headers: authorizationHeader(accessToken)
  });
};
var userService = {
  fetchUserSubscription: fetchUserSubscription
};

export { userService as default, fetchUserSubscription };
//# sourceMappingURL=index.js.map
